export default __webpack_public_path__ + "static/upcomingimg3-90f667eb2556af52a57737b488b498b5.png";